<template>
  <div class="register-layout">
    <nav class="breadcrumb" v-if="nav">
      <template v-for="(it, index) in $pages.filter((x) => x.Name !== 'login')" :key="it.ID">
        <router-link :to="{ name: it.Name }" v-if="$information.steps && $information.steps.indexOf(it.Name) >= 0">
          <div class="item" :class="{ 'is--active': it.Name === name }">
            <el-icon>
              <em-icon-select />
            </el-icon>
            <span>{{ it.Title }}</span>
          </div>
        </router-link>
        <div class="item" :class="{ 'is--active': it.Name === name }" v-else>
          <el-icon>
            <em-icon-select />
          </el-icon>
          <span>{{ it.Title }}</span>
        </div>
      </template>
    </nav>
    <div class="wrapper">
      <div class="top" v-if="$config && $config.layout && $config.layout.top&&!workbench" v-html="$config.layout.top"></div>
      <el-card class="register-form">
        <template #header v-if="$slots.header">
          <slot name="header" />
        </template>
        <slot />
      </el-card>
      <div class="buttom" v-if="$config && $config.layout && $config.layout.bottom&&!workbench" v-html="$config.layout.bottom"></div>
    </div>

    <el-affix position="bottom" :offset="0" v-if="$slots.default&&nav">
      <div class="actions">
        <template v-if="page.prev">
          <el-button class="prev" type="primary" plain @click="$router.push({ name: 'index' })" v-if="page.prev != null && page.prev.Name === 'login'">{{ $t('registration.btn.cancel') }}</el-button>
          <el-button class="prev" type="primary" plain @click="$router.push({ name: page.prev.Name })" v-else>{{ $t('registration.btn.prev') }}</el-button>
        </template>
        <template v-else>
          <el-button class="cancel" type="primary" plain @click="$router.push({ name: 'index' })">{{ $t('registration.btn.cancel') }}</el-button>
        </template>
        <template v-if="page.next">
          <el-button class="next"  type="primary" @click="emit('next', page.next.Name)">{{ $t('registration.btn.next') }}</el-button>
        </template>
        <template v-else-if="name === 'confirmation'">
          <el-button type="primary" @click="$router.push({ name: 'personalcenter-confirmation' })">{{ $t('registration.btn.personal') }}</el-button>
        </template>
        <template v-else></template>
      </div>
    </el-affix>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch, computed, inject } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import { useRegister } from '@/hooks/useRegister'
  import { getInformation } from '@/api/registration'
  import { getPageConfig, getSteps } from '@/api/config'
  import { ElMessage, ElLoading } from 'element-plus'
  import Loading from '@/components/Loading'
  import VSideBar from './sidebar.vue'

  const props = defineProps({
    name: {
      type: String,
      default: '',
    },
    nav: {
      type: Boolean,
      default: true,
    },

    workbench: {
      type: Boolean,
      default: false,
    },
  })

  const emit = defineEmits(['mounted', 'next'])
  const $pages = inject('$steps')
  const $event = inject('$event')
  const $config = inject('$config')
  const $information = inject('$information')

  const page = computed(() => {
    let obj = { current: null, prev: null, next: null }
    for (var i = 0, len = $pages.value.length; i < len; i++) {
      let it = $pages.value[i]
      if (it.Name == props.name) {
        obj.current = it
        if (i > 0) {
          obj.prev = $pages.value[i - 1]
        }
        if (i < len - 1) {
          obj.next = $pages.value[i + 1]
        }
        break
      }
    }
    return obj
  })
</script>

<style lang="scss" scoped>
  .register-form {
    margin-top: 0;
    &.el-card {
      margin: 0 0 0 0;
      background: rgba(255, 255, 255, 0.93);
      border-radius: 12px;
      box-shadow: none;
      border-width: 0;
      :deep() {
        > .el-card__header {
          padding: 20px 24px;
          padding-bottom: 0;
          border-bottom-width: 0;
          font-size: 16px;
          line-height: 22px;
          color: #363f5e;
          font-weight: bold;
        }
      }
    }
  }

  .wrapper {
    margin-top: 20px;
    margin-bottom: 20px;
    min-height: calc(100vh - 250px);
    .top,
    .buttom {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 14px;
      line-height: 22px;
      color: rgba(34, 51, 68, 0.68);
      :deep(){
        p,span{
          word-break: break-word;
        }
       
      }
    }
  }
  .actions {
    background: #ffffff;
    border-radius: 8px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-button {
      width: 110px;
      height: 40px;
    }
  }
  .el-affix {
    .el-affix--fixed {
      .actions {
        box-shadow: inset 0px 0px 6px #f0f0f0;
      }
    }
  }

  .breadcrumb {
    position: relative;
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      text-decoration: none !important;
    }
    &::before {
      content: '';
      position: absolute;
      top: 15px;
      left: 0;
      right: 0;
      height: 1px;
      background-color: rgba(53, 59, 85, 0.12);
      z-index: 98;
    }
    .item {
      position: relative;
      background-color: #eef2f8;
      padding: 0 0px;
      z-index: 99;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      .el-icon {
        width: 26px;
        height: 26px;
        margin-bottom: 6px;
        font-size: 26px;
      }
      span {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: rgba(53, 59, 85, 0.68);
        text-decoration: none;
        font-style: normal;
      }
      &.is--active {
        .el-icon {
          svg {
            :deep() {
              path {
                &:nth-child(1) {
                  fill: var(--el-color-primary);
                  fill-opacity: 1;
                }
                &:nth-of-type(2) {
                  stroke: #fff;
                  stroke-opacity: 1;
                }
              }
            }
          }
        }
        span {
          color: var(--el-color-primary);
        }
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .breadcrumb {
      .item {
        span{
          font-size:12px
        }
      }
    }
  }
</style>
